import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionMenuCatalogUpdatePayload,
	IActionMenuCatalogUpdatePayloadDone,
	IActionMenuCatalogUpdatePayloadError,
} from './types';

export const menuCatalogUpdate = actionCreatorAsync<
	IActionMenuCatalogUpdatePayload,
	IActionMenuCatalogUpdatePayloadDone,
	IActionMenuCatalogUpdatePayloadError
>(
	'menuCatalogUpdate',
	async (params) => {
		const { id, meal, title } = params;
		const { data } = await Api.menuCatalog.update({
			params: { id },
			body: { meal, title },
		});

		return data;
	},
);
